import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
// import baguetteBox from 'baguettebox.js/src/baguetteBox';

/**
 * @file Handles Masonry layout of image gallery and opens thumbs in lightbox gallery
 * @author michael.schmid@notch-interactive.com
 *
 * @module modules/m40-image-gallery
 * @module modules/m29-lightbox
 *
 *
 */

const defaults = {
    baguetteBoxContainer: '.m-image-gallery',
    masonryContainer: '.grid',
    masonryColumnWidth: '.grid-sizer',
    masonryItemSelector: '.grid-item',
    boundAttr: 'data-gallery-bound'
};


/**
 * Initialize module
 *
 * @param {object} options - Override default settings with options object.
 * @param {object} container - Container that contains the image gallery to be initialized.
 * @return {object} Instance of created module.
 */

export default (container, options) => {
    const instance = {};
    let settings = Object.assign({}, defaults, options),
        msnry = {};

    // Make sure all images are loaded
    let masonryContainer = container.querySelector(settings.masonryContainer);

    if (masonryContainer !== null) {
        imagesLoaded(masonryContainer, function () {

            // Only then initialize Masonry as layout calculation can be buggy otherwise
            msnry = new Masonry(masonryContainer, {
                gutter: 0,
                columnWidth: settings.masonryColumnWidth,
                itemSelector: settings.masonryItemSelector,
                percentPosition: true,
                horizontalOrder: true
            });

            // Only fade in pictures after layout has completed - to that only once
            msnry.once('layoutComplete', () => {
                container.style.opacity = 1;
            });

            // Trigger layout method in order to get the layoutComplete event
            msnry.layout();

        });
    }

    // Handle clicks on for image cta
    container.addEventListener('click', (e) => {
        let tmp;

        if (tmp = e.target.closest('[data-action]')) {

            // Imitate a href
            window.location.href = tmp.getAttribute('data-action');
        }
    });

    // Set the bound Attribute, so that this module doesn't initiate the factory multiple times over the same elements
    container.setAttribute(settings.boundAttr, '');

    instance.refresh = () => {
        if (msnry) {
            msnry.layout();
        }
    };

    return instance;
};
